/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import LoginForm from '../Login/LoginForm';
import './TitlePage.css';

function TitlePage(props) {
  const {
    closeLogin,
    showLogin,
    updateUserData,
    setPlayerVerified,
  } = props;

  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    setShowLoginModal(showLogin);
  }, [showLogin]);

  function loginBtnClicked() {
    // decide what to do based on what stage of connecting the wallet + game that the
    // user is on

    setShowLoginModal(true);
  }

  function onCloseLoginModal() {
    setShowLoginModal(false);
    closeLogin();
  }

  function onLoginSuccess() {
    setShowLoginModal(false);
    toast.success('Successfully logged in', {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }

  return (
    <div className="title-header">
      <div className="home-header">
        <h1>Run Legends Account Portal </h1>
        <button className="button" onClick={loginBtnClicked}>Login</button>
        <LoginForm
          isShowLogin={showLoginModal}
          onLoginSuccess={onLoginSuccess}
          onCloseLoginModal={onCloseLoginModal}
          updateUserData={updateUserData}
          setPlayerVerified={setPlayerVerified}
        />
      </div>

      <div className="dash" />
      <div className="arrow bounce" />
    </div>
  );
}

TitlePage.propTypes = {
  closeLogin: PropTypes.func.isRequired,
  showLogin: PropTypes.bool.isRequired,
  updateUserData: PropTypes.func.isRequired,
};

export default TitlePage;
